/**
 * Domain Asset Map
 * 
 * This utility maps domains to their brand assets for local fallback.
 * Used when API calls fail or during development when CORS might be an issue.
 * 
 * Format:
 * - Keys are domain names (without protocols, without 'ai.' prefix)
 * - Values are objects with paths to brand assets
 */

const domainAssetMap = {
  // Example entry for mydomain.com
  'mydomain.com': {
    name: 'Example Company',
    brandAssets: {
      isProcessed: true,
      brandMarkWordMark: {
        original: '/fallback-assets/mydomain/logo.png',
        white: '/fallback-assets/mydomain/logo-white.png',
        black: '/fallback-assets/mydomain/logo-black.png',
      }
    }
  },
  
  // Add more domains as needed
};

/**
 * Get brand assets for a domain
 * @param {string} domain - The domain name (without protocol, may include 'ai.' prefix)
 * @returns {Object|null} - Brand assets object or null if not found
 */
export const getBrandAssetsForDomain = (domain) => {
  if (!domain) return null;
  
  // Remove protocol if present
  let cleanDomain = domain.replace(/^https?:\/\//, '');
  
  // Remove 'ai.' prefix if present
  if (cleanDomain.startsWith('ai.')) {
    cleanDomain = cleanDomain.substring(3);
  }
  
  // Return the assets or null if not found
  return domainAssetMap[cleanDomain] || null;
};

export default domainAssetMap; 